<template>
  <v-ons-page class="ja-material-delete page">
    <common-header>
      <template #header>
        <Button modifier="quiet" class="header-button header-back-button" @click="goBack">
          <v-ons-icon icon="md-chevron-left" />
        </Button>
        <span class="header-title">選択して画像を削除</span>
        <button class="header-button header-cancel-button" @click="cancel">キャンセル</button>
      </template>
    </common-header>
    <div v-show="displayState === DISPLAYSTATE.LOADING_DONE">
      <div class="materials">
        <template v-if="selfMaterials.length">
          <ja-material-delete-cell
            v-for="selfMaterial in selfMaterials"
            :key="selfMaterial.materialId"
            :material="selfMaterial"
            :getMaterial="getMaterial"
          />
        </template>
        <empty-content :emptyPageNum="EMPTY_PAGE_NUM.MATERIAL" v-else />
      </div>
    </div>
    <progress-circular v-show="displayState === DISPLAYSTATE.LOADING_PROGRESS" />
  </v-ons-page>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import JaMaterialDeleteCell from '@/components/JaContent/JaMaterialDeleteCell.vue';
import EmptyContent from '@/components/common/EmptyContent.vue';
import ProgressCircular from '@/components/common/ProgressCircular.vue';
import CommonHeader from '@/components/common/CommonHeader.vue';
import { useRouter } from 'vue-router';
import { dataFetchMaterials } from '@/composable/data_fetch_common';
import Button from '@/components/common/Button.vue';
import { EMPTY_PAGE_NUM } from '@/composable/constant_common';

// 自分の素材一覧
const selfMaterials = ref([]);
// ローディング完了フラグ
const isLoadingDone = ref(false);
// ローディングステータス
// LOADING_PROGRESS: ロード中
// LOADING_DONE: ロード完了
const DISPLAYSTATE = {
  LOADING_PROGRESS: 'ロード中',
  LOADING_DONE: 'ロード完了',
};

// 画面表示状態
const displayState = computed(() => {
  return isLoadingDone.value ? DISPLAYSTATE.LOADING_DONE : DISPLAYSTATE.LOADING_PROGRESS;
});

// 素材一覧取得処理
const getMaterial = async () => {
  isLoadingDone.value = false;
  const materials = await dataFetchMaterials();
  selfMaterials.value = materials.selfMaterialList;
  isLoadingDone.value = true;
};

// ルーター操作
const router = useRouter();
const goBack = () => {
  router.back();
};

const cancel = () => {
  router.replace('/ja/content/materialSelect');
};

// コンポーネントがマウントされたときに呼び出す
onMounted(() => {
  getMaterial();
});
</script>

<style scoped>
/* ヘッダ */
.header-title {
  padding-right: 5rem;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}
.header-button {
  background: transparent;
  position: absolute;
}
.header-back-button {
  color: #aaaaaa;
  font-size: 10vmin;
  left: 5%;
}
.header-cancel-button {
  padding: 1rem;
  border: 1px #ddd solid;
  border-radius: 0.5rem;
  color: #222;
  right: 0.5rem;
  font-size: 1.5rem;
}

/* 素材ラッパー */
.materials {
  display: flex;
  flex-wrap: wrap;
  gap: 0.1rem;
  width: 100%;
  background-color: #fff;
  padding-top: 10vh;
  z-index: 1;
}
</style>
